import { create } from "zustand";

export type SummaryData = {
  content: string;
  hint?: Array<{
    term: string;
    definition: string;
  }>;
};

export type SummaryType = "summary" | "snapshot";

type SummaryByChat = Record<string, Partial<Record<SummaryType, SummaryData>>>;

interface SummaryState {
  summariesByChat: SummaryByChat;
  getSummary: (chatId: string, type: SummaryType) => SummaryData | undefined;
  setSummary: (chatId: string, type: SummaryType, data: SummaryData) => void;
  clearSummary: (chatId: string, type?: SummaryType) => void;
  clearAll: () => void;
}

export const useSummaryStore = create<SummaryState>((set, get) => ({
  summariesByChat: {},

  getSummary: (chatId: string, type: SummaryType) =>
    get().summariesByChat[chatId]?.[type],

  setSummary: (chatId: string, type: SummaryType, data: SummaryData) => {
    set((state) => ({
      summariesByChat: {
        ...state.summariesByChat,
        [chatId]: {
          ...state.summariesByChat[chatId],
          [type]: data,
        },
      },
    }));
  },

  clearSummary: (chatId: string, type?: SummaryType) => {
    set((state) => {
      if (!type) {
        const { [chatId]: removed, ...rest } = state.summariesByChat;
        return { summariesByChat: rest };
      } else {
        const chatSummaries = state.summariesByChat[chatId];
        if (!chatSummaries) return state;

        const { [type]: removed, ...restTypes } = chatSummaries;
        return {
          summariesByChat: {
            ...state.summariesByChat,
            [chatId]: restTypes,
          },
        };
      }
    });
  },

  clearAll: () => {
    set({ summariesByChat: {} });
  },
}));
